export function Video() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative w-full h-0 pb-[56.25%] rounded-lg overflow-hidden shadow-lg">
          <iframe
            src="https://www.youtube.com/embed/HKzG9XzV4JQ?wmode=opaque"
            title="The Conservatory of Musical Arts Performance"
            className="absolute top-0 left-0 w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}